import { APIRequest, APIRequestDtoImpl } from '../apiRequest';
import { ForgotPasswordDto } from '../../dto/forgotpassword/forgotpassworddto';


export interface ForgotPasswordRequest extends APIRequest
{
    getForgotPasswordRequest(): ForgotPasswordDto;
}

export class ForgotPasswordRequestImpl extends APIRequestDtoImpl implements ForgotPasswordRequest
{
    constructor(private forgotPasswordData: ForgotPasswordDto)
    {
        super();
    }

    getForgotPasswordRequest(): ForgotPasswordDto
    {
        return this.forgotPasswordData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/forgotpassword/forgotpasswordrequest.tsx